import fetch from 'utils/request';
import { deepCopy, isArray } from 'utils/index';


// ! 客户列表查询
export function apiPostCustomerList(data){
    return fetch({
        url: '/scv/webService/customer/queryCustomerList',
        method: 'post',
        data: data,
		contentType: 'formData'
    });
}

// ! 客户详情查询
export function apiPostCustomerInfo(data) {
	return fetch({
        url: '/scv/webService/customer/queryCustomerDetailInfo',
        method: 'post',
        data: data,
		contentType: 'formData'
    });
}

// ! 客户详情 - 客户字段
export function apiQueryTabColumn(data) {
	return fetch({
		url: '/scv/tableColumn/queryList.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 新增客户
export function apiAddCustomer(data) {
	data = deepCopy(data);
	Object.keys(data).forEach(i => {
		if(isArray(data[i])) {
			data[i] = data[i].toString();
		}
	});
	delete data.extendData;
	return fetch({
		url: '/scv/webService/customer/addCustomer',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 修改客户
export function apiUpdateCustomer(data) {
	data = deepCopy(data);
	Object.keys(data).forEach(i => {
		if(isArray(data[i])) {
			data[i] = data[i].toString();
		}
	});
	if(data.phoneNumberDesensitize && !(data.phoneNumberDesensitize.indexOf("**") != -1)) {
		data.phoneNumber = data.phoneNumberDesensitize;
	}
	if(data.phoneNumberDesensitize2 && !(data.phoneNumberDesensitize2.indexOf("**") != -1)) {
		data.phoneNumber2 = data.phoneNumberDesensitize2;
	}
	if(data.phoneNumberDesensitize3 && !(data.phoneNumberDesensitize3.indexOf("**") != -1)) {
		data.phoneNumber3 = data.phoneNumberDesensitize3;
	}
	delete data.phoneNumberDesensitize;
	delete data.phoneNumberDesensitize2;
	delete data.phoneNumberDesensitize3;
	delete data.extendData;
	return fetch({
		url: '/scv/webService/customer/updateCustomer',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 客户变更记录
export function apiCustomerOperationLog(data) {
	return fetch({
		url: '/scv/webService/operationLog/queryCustomerOperationLog',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 客户变更记录
export function apiIaIncidentList(data) {
	return fetch({
		url: '/ia/incident/queryIncidentPage.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	});
}

// ! 客户详情 - 沟通小结查询
export function apiPostIncident(data) {
	return fetch({
        url: '/ia/incident/queryIncidentPage.json',
        method: 'post',
        data: data,
		contentType: 'formData'
    });
}

// ! 上传文件
export function apiPostUploadFile(data) {
	return fetch({
        url: '/ocs-file/uploadFile',
        method: 'post',
        data: data
    });
}

// ! 发送短信
export function apiPostSendDX(data) {
	return fetch({
        url: '/ocs-sms/saveQuickSms',
        method: 'post',
        data: data
    });
}


// ! 发送IM留言
export function apiPostSendWeiXinLy(appId, openId, data) {
	return fetch({
        url: `/livechat/msg/send/${appId}/${openId}`,
        method: 'post',
        data: data
    });
}

// ! 查询相似客户
export function apiPostCustomerAllInfo(data) {
	return fetch({
        url: `/scv/webService/customer/queryCustomerAllInfo`,
        method: 'post',
        data: data,
		contentType: 'formData'
    });
}
